import axios from 'axios'

import { getServerUrl } from '../../../functions/getServerUrl'

import {
  savingChartPhase,
  errorSavingChartPhase,
  alertChartHasBeenSaved,
 } from './chartFormReducer'

const defaultState = {
  age: '',
  gender: '',
  race: '',
  countryOfBirth: '',
  placeOfResidence: '',
  placeOfResidenceOther: '',
  demographicsInfoUrl: null,
}

export default function patientDemographicsFormReducer(state = defaultState, action) {
  switch (action.type) {
    case "CHANGE_EDIT_CHART_PHASE":
      return { ...state, chartPhase: action.payload }
    case "HANDLE_DEMOGRAPHIC_FORM_FIELD_CHANGE":
      return { ...state, [action.payload.key]: action.payload.value }
    case "CHART_DEMOGRAPHICS_INFO_HAS_BEEN_SAVED":
      return { ...state, demographicsInfoUrl: action.payload.demographicsInfoUrl }
    case "SET_CHART_FROM_SERVER_TO_FORM":
      if (action.payload.patient_demographics) {
        const demographics = action.payload.patient_demographics
        return {
          ...state,
          age: demographics.age || '',
          gender: demographics.gender || '',
          race: demographics.race || '',
          countryOfBirth: demographics.country_of_birth || '',
          placeOfResidence: demographics.place_of_residence || '',
          placeOfResidenceOther: demographics.place_of_residence_other_text || '',
          demographicsInfoUrl: demographics.url || '',
        }
      } else {
        return state
      }
    case "MARK_CHART_AS_COMPLETED":
      return defaultState
    case "CHART_HAS_BEEN_DELETED":
      return defaultState
    default:
      return state
  }
}


export const handleDemographicChartFieldChange = (key, value) => {
  return { type: "HANDLE_DEMOGRAPHIC_FORM_FIELD_CHANGE", payload: { key, value } }
}



const chartDemographicsInfoHasBeenSaved = (demographicsInfoUrl, goToNextPhase) => {
  return { type: "CHART_DEMOGRAPHICS_INFO_HAS_BEEN_SAVED", payload: {demographicsInfoUrl, goToNextPhase} }
}


export const submitChartDemographicsInfo = (props, goToNextPhase) => {

  const {
    patientChartUrl,
    demographicsInfoUrl,
    age,
    gender,
    race,
    countryOfBirth,
    placeOfResidence,
  } = props

  //if placeOfResidence is not other, clear out field and set to null
  let placeOfResidenceOther = props.placeOfResidenceOther
  if (placeOfResidence !== 'Other') {
    placeOfResidenceOther = null
  }

  return (dispatch, getState) => {
    const chartIsSaving = getState().chartFormReducer.savingChartPhase
    if (chartIsSaving) {
      return dispatch({ type: '' })
    }

    dispatch(savingChartPhase())

    const demographicsInfo = {
      patient_chart: patientChartUrl  || null,
      age: age  || null,
      gender: gender || null,
      race: race || null,
      country_of_birth: countryOfBirth  || null,
      place_of_residence: placeOfResidence  || null,
      place_of_residence_other_text: placeOfResidenceOther || null,
    }

    let method, url

    if (demographicsInfoUrl) {
      method = "PATCH"
      url = demographicsInfoUrl
    } else {
      method = "POST"
      url = `${getServerUrl()}/patient-demographics/`
    }

    axios({
      method,
      url,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
      data: demographicsInfo,
    })
    .then(response => {

      alertChartHasBeenSaved(props)

      dispatch(chartDemographicsInfoHasBeenSaved(response.data.url, goToNextPhase))
    })
    .catch(error => {
      dispatch(errorSavingChartPhase(error, "Patient Demographics", dispatch))
    })
  }
}
